import { Component } from '@angular/core';

import {DomSanitizer} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ECMService } from '../services/ecm.service';
import { AppConfig } from 'src/assets/config/config/app-config';
import { PDFDocument, PDFName } from 'pdf-lib';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login-user.component.html',
  styleUrls: ['./login-user.component.css']
})
export class LoginUserComponent {

  documentId: string;
  userName: string;
  fileUrl: any;
  showDownloadMessage: boolean = false;
  downloadUrl: string = '';
  sanitizer: DomSanitizer;
  isIE: boolean = false;

  constructor(route: ActivatedRoute, sanitizer: DomSanitizer, public router: Router, public ecmService: ECMService, private config: AppConfig, private http: HttpClient) {
    this.sanitizer = sanitizer;
    this.isIE = this.detectIE();

    // if (route.snapshot.queryParams['documentId'] && route.snapshot.queryParams['documentId'] !== '') {
    //   let documentId = route.snapshot.queryParams['documentId'];
    //   let fileType = route.snapshot.queryParams['fileType'];
    //   let userName = route.snapshot.queryParams['userName'];
    //   this.fileUrl = sanitizer.bypassSecurityTrustResourceUrl(`${environment.docurl}?&docId=${documentId};${fileType};${userName}`);
    // }

    this.documentId = route.snapshot.queryParams['documentId'];
    let fileType = route.snapshot.queryParams['fileType'];
    this.userName = route.snapshot.queryParams['userName'];
    if (this.documentId == undefined || this.documentId == null || this.documentId === "") {
      this.documentId = localStorage.getItem('docId') || '';
    }
    if (fileType == undefined || fileType == null || fileType === "") {
      fileType = localStorage.getItem('fileType') || '';
    }
    let supportedFileTypes = this.config.getConfig("downloadFileType");
    let syncfusionSupportedFileType = this.config.getConfig("syncfusionSupportedFileType");
    if (supportedFileTypes.includes(fileType)) {
      this.showDownloadMessage = true;
    } else if (syncfusionSupportedFileType.includes(fileType)) {
      const docurl = this.config.getConfig("docurl");
      this.fileUrl = sanitizer.bypassSecurityTrustResourceUrl(`${docurl}?&docId=${this.documentId};${fileType};${this.userName}`); 
    } else {
      if (fileType === "application/pdf") {
          this.verifyPDFFile(this.documentId,this.userName);
      } else {
        this.viewBrowserDocument(this.documentId, this.userName);
      }        
    }    
    if (this.documentId && fileType && this.userName) {
      localStorage.setItem('isDocLoad', 'true');
    } else {
      localStorage.setItem('isDocLoad', 'false');
    }
  }

  detectIE(): boolean {
    // Only genuine IE (MSIE/Trident) needs the download-only fallback; Edge can render PDFs inline.
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');
    const trident = ua.indexOf('Trident/');
    return (msie > 0 || trident > 0);
  }

  viewDocument(docId: string, userName: string) {
    this.ecmService.viewDocument(docId, userName)
        .subscribe(
            resp => {
                if (resp !== "") {
                  var url = resp.slice(5);
                  let newWindow = window.open();
                  if (newWindow) {
                    newWindow.location = url as any;
                    setTimeout(function() {
                      if (newWindow) {
                        newWindow.close();
                      }                    
                    }, 2000);
                  }
                }
            }
        ); 
  }

  viewBrowserDocument(docId: string, userName: string) {
    this.ecmService.viewDocument(docId, userName)
        .subscribe(
            resp => {
                if (resp !== "") {
                  var url = resp.slice(5);
                  // Add view parameters to prevent edit mode and display in iframe
                  this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#view=FitH&zoom=80&toolbar=0&navpanes=0&scrollbar=1');
                }
            }
        ); 
  }


  getDownloadUrl(docId: string, userName: string) {
    return new Promise((resolve, reject) => {
      this.ecmService.viewDocument(docId, userName)
          .subscribe(
              resp => {
                  if (resp !== "") {
                    var url = resp.slice(5);
                    this.downloadUrl = url;  
                    resolve(url);              
                  } else {
                    reject('Empty response');
                  }
                }
        );
    });
  }

  downloadFile() {
    this.getDownloadUrl(this.documentId, this.userName)
    .then(url => {
      window.open(this.downloadUrl, '_blank');
    });
  }


  async verifyPDFFile(docId: string, userName: string) {
    let resp = await this.ecmService.viewDocument(docId, userName).toPromise();
    if (resp !== "") {
      var url = resp.slice(5);
      
      // For IE, skip portfolio check and use direct viewing or download
      if (this.isIE) {
        // IE has poor native PDF support, provide download option
        this.showDownloadMessage = true;
        this.downloadUrl = url;
        window.alert("Internet Explorer has limited PDF viewing support. Please use the download button to view the document in Adobe Reader.");
      } else {
        // Malformed PDFs (broken xref entries) can make pdf-lib's recovery parser very slow on IE/Edge; fail open after a timeout.
        var result = await this.withTimeout(this.isPdfPortfolio(url), 5000, false);
        if (result) {
          window.alert("Viewer doesn't support PDF Portfolio file, Please download and view it with Adobe Reader");
        } else {
          // Add parameters to prevent edit mode and optimize viewing
          // view=FitH - Fit to width
          // toolbar=0 - Hide toolbar (reduces edit options)
          // navpanes=0 - Hide navigation panes
          // scrollbar=1 - Keep scrollbar
          this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#view=FitH&zoom=80&toolbar=0&navpanes=0&scrollbar=1');
        }
      }               
    }
  }

  withTimeout<T>(promise: Promise<T>, ms: number, fallback: T): Promise<T> {
    const timeout = new Promise<T>(resolve => setTimeout(() => resolve(fallback), ms));
    return Promise.race([promise, timeout]);
  }

  async isPdfPortfolio(pdfFile: string) {
    try {
      // Load the PDF document using HttpClient for better browser compatibility
      const existingPdfBytes = await this.http.get(pdfFile, { responseType: 'arraybuffer' }).toPromise();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
    
      // Access the PDF catalog
      const catalog = pdfDoc.catalog;
    
      // Check for portfolio-specific entries in the catalog
      const isPortfolio = catalog.has(PDFName.of('Collection'));
    
      return isPortfolio;
    } catch (error) {
      console.error('Error checking PDF portfolio:', error);
      return false; // Default to false if check fails
    }
  }

  async hasFillableFormFields(pdfFile: string) {
    try {
      const existingPdfBytes = await this.http.get(pdfFile, { responseType: 'arraybuffer' }).toPromise();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const form = pdfDoc.getForm();
      const fields = form.getFields();
      return fields.length > 0;
    } catch (error) {
      console.error('Error checking form fields:', error);
      return false;
    }
  }



  async isPasswordProtected(pdfFile: string) {
    try {
      const pdfBytes = await this.http.get(pdfFile, { responseType: 'arraybuffer' }).toPromise();
      await PDFDocument.load(pdfBytes);
      return false; // No password
    } catch (error: any) {
      if (error && error.message && error.message.includes('password')) {
        return true; // Password protected
      } else {
        throw error; // Other error occurred
      }
    }
  }
 
}
